import { SET_ORGANIZATION_LIST, SET_ORGANIZATION_VIEWS_LIST } from '../types/organization'

const initState = {
  organizationsList: {},
  organizationViewsList: [],
  organizationViewsMap: {},
  lastModified: new Date().getTime(),
}

export default (state = initState, action) => {
  switch (action.type) {
    case SET_ORGANIZATION_LIST:
      return {
        ...state,
        organizationsList: action.payload.organizations,
        lastModified: new Date().getTime(),
      }
    case SET_ORGANIZATION_VIEWS_LIST:
      return {
        ...state,
        organizationViewsList: action.payload.organizationViews,
        organizationViewsMap: action.payload.organizationViews.reduce((map, view) => {
          map[view.id] = view
          return map
        }, {}),
        lastModified: new Date().getTime(),
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/organization.js